var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 0.00585938C4.37206 0.00585938 -0.00292969 8.80971 -0.00292969 8.80971C-0.00292969 8.80971 4.37206 17.6136 11.7512 17.6136C18.9554 17.6136 23.3304 8.80971 23.3304 8.80971C23.3304 8.80971 18.9554 0.00585938 11.7512 0.00585938ZM11.6637 2.94048C14.9012 2.94048 17.497 5.58163 17.497 8.80971C17.497 12.0671 14.9012 14.6789 11.6637 14.6789C8.45539 14.6789 5.8304 12.0671 5.8304 8.80971C5.8304 5.58163 8.45539 2.94048 11.6637 2.94048ZM11.6637 5.87509C10.0596 5.87509 8.74706 7.19567 8.74706 8.80971C8.74706 10.4237 10.0596 11.7443 11.6637 11.7443C13.2679 11.7443 14.5804 10.4237 14.5804 8.80971C14.5804 8.51625 14.4637 8.25213 14.4054 7.98802C14.1721 8.45755 13.7054 8.80971 13.1221 8.80971C12.3054 8.80971 11.6637 8.16409 11.6637 7.3424C11.6637 6.75548 12.0137 6.28594 12.4804 6.05117C12.2179 5.96313 11.9554 5.87509 11.6637 5.87509Z",
    fill: "#29348F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.de2f615f90b7dfd9561d67396581f787.svg";
export { ForwardRef as ReactComponent };